import { Link } from "react-router-dom";

export function Logo({ size = "md", testid = "header-logo-link" }) {
  return (
    <Link to="/" data-testid={testid} aria-label="Casa C'è – Home" className="inline-flex shrink-0 items-center">
      <img
        src="/img/casace-logo-200.webp"
        srcSet="/img/casace-logo-200.webp 200w, /img/casace-logo-400.webp 400w, /img/casace-logo-640.webp 640w"
        sizes={size === "lg" ? "380px" : "120px"}
        width="200"
        height="97"
        alt="Casa C'è – Il tuo sì, il tuo sogno, la tua casa."
        className="h-11 w-auto rounded-md object-contain sm:h-12"
        style={{ aspectRatio: "1325 / 640" }}
      />
    </Link>
  );
}
